import React, { useState } from 'react';

const AddUserModal = ({ newUser, handleInputChange, handleAddUser, isEditMode }) => {
  const [errors, setErrors] = useState({});
  const [roleOptions, setRoleOptions] = useState([
    { id: 1, name: 'Super Admin' },
    { id: 2, name: 'Resource Manager' },
    { id: 3, name: 'End User' }
  ]);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ['first_name', 'email', 'role'];
    
    if (!isEditMode && !newUser.password) {
      requiredFields.push('password');
    }

    requiredFields.forEach(field => {
      if (!newUser[field] || !newUser[field].toString().trim()) {
        newErrors[field] = `${field.replace('_', ' ')} is required`;
      }
    });

    // Email validation
    if (newUser.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newUser.email)) {
      newErrors.email = 'Invalid email format';
    }

    // Phone validation (if provided)
    if (newUser.phone && !/^\d{10,15}$/.test(newUser.phone)) {
      newErrors.phone = 'Phone must be 10-15 digits';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      handleAddUser();
    }
  };

  const getFieldLabel = (field) => {
    return field.replace('_', ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  };

  return (
    <div id="bs-user" className="modal fade" tabIndex="-1" aria-labelledby="bs-user" aria-hidden="true">
      <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header d-flex align-items-center">
            <h5 className="modal-title">{isEditMode ? 'Edit User' : 'Add User'}</h5>
            <button 
              id="closeAddUserModal" 
              type="button" 
              className="btn-close" 
              data-bs-dismiss="modal" 
              aria-label="Close"
              onClick={() => setErrors({})}
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {['first_name', 'last_name', 'username', 'phone', 'email', 'password'].map((field) => (
                  <div key={field} className="col-md-6 mb-3">
                    <label className="form-label">{getFieldLabel(field)}</label>
                    <input
                      type={
                        field === 'email' ? 'email' : 
                        field === 'password' ? 'password' : 
                        field === 'phone' ? 'tel' : 'text'
                      }
                      name={field}
                      value={newUser[field] || ''}
                      onChange={handleInputChange}
                      className={`form-control ${errors[field] ? 'is-invalid' : ''}`}
                      placeholder={`Enter ${getFieldLabel(field)}`}
                      disabled={field === 'password' && isEditMode ? false : false}
                    />
                    {errors[field] && (
                      <div className="invalid-feedback">{errors[field]}</div>
                    )}
                  </div>
                ))}
                
                <div className="col-md-12 mb-3">
                  <label className="form-label">Address</label>
                  <textarea
                    name="address"
                    value={newUser.address || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    rows="3"
                    placeholder="Enter Address"
                  ></textarea>
                </div>
                
                <div className="col-md-12 mb-3">
                  <label className="form-label">Role</label>
                  <select
                    name="role"
                    value={newUser.role || ''}
                    onChange={handleInputChange}
                    className={`form-control form-select ${errors.role ? 'is-invalid' : ''}`}
                  >
                    <option value="">Select Role</option>
                    {roleOptions.map(role => (
                      <option key={role.id} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                  {errors.role && (
                    <div className="invalid-feedback">{errors.role}</div>
                  )}
                </div>
              </div>
              
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-outline-danger" 
                  data-bs-dismiss="modal"
                  onClick={() => setErrors({})}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {isEditMode ? 'Update User' : 'Save User'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUserModal;